import React, { ReactNode, useRef } from "react"

import { BackgroundColor } from "../layout"
import Container from "../layout/container"
import SliderNavigation from "./navigation"
import classNames from "classnames"
import { useMediaQuery } from "../../../hooks/use-media-query-admin"
import { useSlider } from "../../../shared/hooks/use-slider"

interface GridSliderProps {
    children: ReactNode
    length: number
    bgColor?: BackgroundColor
}

const GridSlider = ({ children, length, bgColor }: GridSliderProps) => {
    const isMobile = useMediaQuery("(max-width: 767px)", { initializeWithValue: false })
    const isTabletPortrait = useMediaQuery("(max-width: 1023px)", { initializeWithValue: false })
    const isTabletLandscape = useMediaQuery("(max-width: 1365px)", { initializeWithValue: false })

    const sliderWrapperRef = useRef<null | HTMLDivElement>(null)

    const gap = isMobile ? 10 : isTabletPortrait ? 14 : isTabletLandscape ? 20 : 24
    const realLength = isMobile ? length : length - 2 < 0 ? length : length - 2

    const { handleDragStart, handleDragMove, handleDragEnd, index, lastIndex, transition, goTo } = useSlider(
        realLength,
        sliderWrapperRef,
        0
    )

    return (
        <div className="overflow-hidden" ref={sliderWrapperRef}>
            <Container>
                <ul
                    className={classNames("grid gap-x-2.5 sm:gap-x-3.5 md:gap-x-5 lg:gap-x-6", {
                        "transition-transform duration-[250ms] ease-in-out": transition,
                        "cursor-grab active:cursor-grabbing": length > 1,
                    })}
                    style={{
                        width: isMobile
                            ? `calc((100% * ${length} + ${gap}px * ${length - 1})`
                            : `calc(((100% - 2 * ${gap}px) / 3) * ${length} + ${gap}px * ${length - 1})`,
                        transform: `translateX(calc(${-1 * index} * (100% + ${gap}px) / ${length}))`,
                        gridTemplateColumns: `repeat(${length}, 1fr)`,
                    }}
                    onTouchStart={handleDragStart}
                    onMouseDown={handleDragStart}
                    onTouchMove={handleDragMove}
                    onMouseMove={handleDragMove}
                    onTouchEnd={handleDragEnd}
                    onMouseUp={handleDragEnd}
                    onMouseLeave={handleDragEnd}
                    role="none"
                >
                    {children}
                </ul>
                <SliderNavigation length={realLength} lastIndex={lastIndex} goTo={goTo} bgColor={bgColor} />
            </Container>
        </div>
    )
}

export default GridSlider
